import React from 'react';
import {connect} from 'react-redux'
import * as actions from '../../../store/actions'


class AlertFeed extends React.Component {

    renderAlerts = () => {
        return this.props.alerts.map(d => (
            <article className={`message ${d.type ? `is-${d.type}`: ''}`}>
                {!!d.title &&
                <div className="message-header">
                    <p>{d.title}</p>
                    <button
                        className="delete"
                        aria-label="delete"
                        onClick={() => this.props.removeAlert(d.id)}
                    />
                </div>
                }
                {!!d.body &&
                <div className="message-body">
                    {typeof(d.body) === 'object' ? (d.body.msg || '') : d.body}
                </div>
                }
            </article>
        ))
    }

    render() {
        return (
             <div className="alert-feed">
                 {this.renderAlerts()}
             </div>
        )
    }

}


const mapStateToProps = (state) => ({
    alerts: state.alerts
});

const mapDispatchToProps = dispatch => ({
    removeAlert: alert_id => dispatch(actions.alerts.removeAlert(alert_id)),
    clearAllAlerts: () => dispatch(actions.alerts.clearAllAlerts()),
})

export default connect(mapStateToProps, mapDispatchToProps)(AlertFeed)
